goog.provide("shadow.js.shim.module$react_use$lib$useMeasure");
goog.provide("module$shadow_js_shim_module$react_use$lib$useMeasure");
shadow.js.shim.module$react_use$lib$useMeasure = shadow.js.nativeProvides["react-use/lib/useMeasure"] = shadow$bridge("react-use/lib/useMeasure");
module$shadow_js_shim_module$react_use$lib$useMeasure.default = shadow.js.shim.module$react_use$lib$useMeasure;
